
const initialState = {
    drafts:{
        rerender:0,
        companies:{}
    }
}

const reducer = (state = initialState, action) => {
    let newState = { ...state };
    switch (action.type) {
        case "STATE_CREATE_UPDATE_DRAFTS":
            if(newState.drafts.companies[action.val.company_id]==undefined){
                newState.drafts.companies[action.val.company_id] = {}
            }
            newState.drafts.companies[action.val.company_id][action.val.draft_type]=JSON.parse(JSON.stringify(action.val.draft_data));
            newState.drafts.rerender = newState.drafts.rerender + 1
            break;
        case "STATE_DELETE_DRAFTS":
            console.log(newState.drafts, action.val, 'DELETE');
            if (newState.drafts.companies[action.val.company_id] != undefined && newState.drafts.companies[action.val.company_id][action.val.draft_type]!=undefined){
                delete newState.drafts.companies[action.val.company_id][action.val.draft_type];
            }
            newState.drafts.rerender = newState.drafts.rerender + 1;
    }
    return newState;
}

export default reducer;
